import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const MidPageCta = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="py-12 md:py-16 bg-[#F8FAFC]" data-testid="mid-page-cta">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row items-center justify-between gap-6 bg-[#003333] rounded-2xl px-8 py-8 md:px-12 md:py-10"
        >
          <p className="text-lg md:text-xl font-medium text-white text-center md:text-left">
            Already know what you need built? Skip the reading.
          </p>
          <Link
            to="/consultation"
            className="shrink-0 inline-flex items-center justify-center gap-2 bg-white text-[#003333] hover:bg-white/90 rounded-full px-6 py-3 text-sm font-medium transition-all duration-300 hover:scale-105"
            data-testid="mid-cta-consultation"
          >
            Book Consultation
            <ArrowRight className="w-4 h-4" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
